module.exports = __webpack_public_path__ + "static/img/login_phone.079d9b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_phone.png
// module id = L1CM
// module chunks = 1